module.exports = __webpack_public_path__ + "d94e20c1/img/product-icon-grey.b248963c.svg";